import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api'
import { AffiliateDashboardFilterInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface'
import { isDefaultFilter } from 'modules/affiliate-program/utils/is-default-filter'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export const useAffiliateDashboardChart = (filter: AffiliateDashboardFilterInterface) => {
  const { fetcher } = useFetch<RequestMethodsEnum.get, any>({
    method: RequestMethodsEnum.get,
  })
  const { user } = useUser()

  const filterApi = `${filter.dateSince !== null ? `filter[dateSince]=${filter.dateSince}` : ''}${
    filter.dateTill !== null ? `&filter[dateTill]=${filter.dateTill}` : ''
  }`

  return useSWR(() => {
    if (
      !user ||
      isDefaultFilter({ dateSince: filter.dateSince, dateTill: filter.dateTill }, user.timezone) ||
      !filterApi
    )
      return
    if (filter.vendorId) {
      return `${AFFILIATE_DASHBOARD_API}/chart/${filter.vendorId}?${filterApi}`
    } else {
      return `${AFFILIATE_DASHBOARD_API}/chart?${filterApi}`
    }
  }, fetcher)
}
